import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout, updateUser } from '~redux_related/user/actionCreators';
import { Loader } from '~components/loader';
import MobileHeader from '~routes/main/userprofile/mobile-header';
import DesktopHeader from '~routes/main/userprofile/desktop-header';
import Navigation from '~routes/main/userprofile/navigation';
import UserCard from '~routes/main/userprofile/user-card';
import TabSettingsLazy from '~routes/main/userprofile/tab-settings/lazy';
import TabTeamLazy from '~routes/main/userprofile/tab-team/lazy';
import TabEventsLazy from '~routes/main/userprofile/tab-events/lazy';
import TabFeedLazy from '~routes/main/userprofile/tab-feed/TabFeedLazy';
import { checkUserExpirationDateExpired} from '~utils/helpers';
import './style.scss';

function UserProfile({
    isMobile,
    isFetching,
    user,
    logout,
    updateUser,
    isNewsUserLogged,
    isLawsUserLogged,
    isLawsAvailable,
}) {
    React.useEffect(() => {
        window.scrollTo(0, 0);
        window.ym && window.ym(73097359, 'hit', window.location.href);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const availabilityProps = { isNewsUserLogged, isLawsUserLogged, isLawsAvailable, user };
    return (
        <div className="user-profile">
            {!isMobile && <DesktopHeader {...availabilityProps} />}

            {/* Mobile */}
            {isMobile && (
                <div className="main-container">
                    <MobileHeader logout={logout} />
                </div>
            )}
            {isMobile && (
                <div className="user-profile__mob-head">
                    <UserCard user={user} logout={logout} updateUser={updateUser} {...availabilityProps} />
                    <Navigation {...availabilityProps} />
                </div>
            )}
            <div className="user-profile__mob-bg">
                <div className="main-container">
                    <div className="user-profile__wrap">
                        <div className="user-profile__tabs-container">
                            <Switch>
                                <Route
                                    path="/user/settings"
                                    exact
                                    render={() => <TabSettingsLazy {...availabilityProps} />}
                                />
                                {isLawsUserLogged && isLawsAvailable && (
                                    <Route path="/user/team" exact render={() => <TabTeamLazy user={user} />} />
                                )}
                                {isLawsUserLogged && isLawsAvailable && (
                                    <Route path="/user/events" exact render={() => <TabEventsLazy user={user} />} />
                                )}
                                {isLawsUserLogged && isLawsAvailable && (
                                    <Route path="/user/feed" exact render={() => <TabFeedLazy user={user} />} />
                                )}
                                <Redirect to="/user/settings" />
                            </Switch>
                        </div>
                        {!isMobile && <UserCard user={user} logout={logout} updateUser={updateUser} {...availabilityProps} />}
                    </div>
                </div>
            </div>

            {/* Desktop */}
            {/* {!isMobile && (
                <div className="main-container">
                    <div className="user-profile__wrap">
                        <div className="user-profile__tabs-container">
                            <Switch>
                                <Route
                                    path="/user/settings"
                                    exact
                                    render={() => <TabSettingsLazy {...availabilityProps} />}
                                />
                                {isLawsUserLogged && isLawsAvailable && (
                                    <Route path="/user/team" exact render={() => <TabTeamLazy user={user} />} />
                                )}
                                {isLawsUserLogged && isLawsAvailable && (
                                    <Route path="/user/events" exact render={() => <TabEventsLazy user={user} />} />
                                )}
                                {isLawsUserLogged && isLawsAvailable && (
                                    <Route path="/user/feed" exact render={() => <TabFeedLazy user={user} />} />
                                )}
                                <Redirect to="/user/settings" />
                            </Switch>
                        </div>
                        <UserCard user={user} logout={logout} updateUser={updateUser} {...availabilityProps} />
                    </div>
                </div>
            )} */}
            {isFetching && <Loader />}
        </div>
    );
}

UserProfile.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    user: PropTypes.shape({
        full_name: PropTypes.string,
        photo: PropTypes.string,
        ut: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
    }).isRequired,
    isNewsUserLogged: PropTypes.bool,
    isLawsUserLogged: PropTypes.bool,
    isLawsAvailable: PropTypes.bool,
    logout: PropTypes.func.isRequired,
    updateUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
    isFetching: state.user.isUserFetching,
    user: state.user,
    isNewsUserLogged: !checkUserExpirationDateExpired(state.user.newsUser.token_expires_at),
    isLawsUserLogged: !checkUserExpirationDateExpired(state.user.lawsUser.token_expires_at),
    isNewsAvailable: state.user.feed_settings && state.user.feed_settings.news,
    isLawsAvailable: state.user.feed_settings && state.user.feed_settings.laws,
});

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(logout()),
    updateUser: (user) => dispatch(updateUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/index.js